<template>
    <div>
        <div class="simulator-box">


            <div class="card-panel">

                <div class="flex-row">
                    <div class="col-xs-12 col-sm">
                        <h2 class="simulator-title loaded" >
                            Configuração do desconto simplificado {{ ano }}
                        </h2>
                    </div>
                    <div class="col-xs-12 col-sm-3 right-align">
                        <a v-if="funcionario_cargo_id === 1" class="btn-floating btn-default" @click.prevent="form({ano})">
                            <i class="large material-icons">add</i>
                        </a>
                    </div>
                </div>
                <table class="responsive-table bordered striped" v-if='descontos_simplificados.length'>
                    <thead>
                        <tr>
                            <th>Valor do salário de contribuição</th>
                            <th>Alíquota de Pagamento</th>
                            <th v-if="funcionario_cargo_id === 1">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in descontos_simplificados" :key="`desconto-simplificado-${item.desconto_simplificado_id}`">
                            <td>
                                <template v-if="item.valor_minimo === null">
                                    Menor que {{ item.valor_maximo | dinheiro }}
                                </template>
                                <template v-else-if="item.valor_maximo == null">
                                    Acima de {{ item.valor_minimo | dinheiro }}
                                </template>
                                <template v-else>
                                    De {{ item.valor_minimo | dinheiro }} até {{ item.valor_maximo | dinheiro }}
                                </template>
                            </td>

                            <td>
                                {{ item.porcentagem ? `${item.desconto}%` : $options.filters.dinheiro(item.desconto) }}
                            </td>
                            <td  width="100" v-if="funcionario_cargo_id === 1" >
                                <a @click.prevent="excluir(item, index)" href class="text-primary">
                                    <i class="material-icons">delete</i>
                                </a>

                                <a href @click.prevent="form(item, index)" class="text-primary">
                                    <i class="material-icons">edit</i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="grey-text">
                    Não há informações cadastradas.
                </div>
            </div>

            <div class="mt-2 right-align">
                <router-link class="btn btn-default" :to="{name: 'configuracoes'}">Concluir</router-link>
            </div>


            <modal :is-active.sync="modal_form" :title="`${desconto_simplificado_selecionado.desconto_simplificado_id ? 'Editar' : 'Cadastrar' } desconto simplificado`">
                <form  @submit.prevent="salvar(desconto_simplificado_selecionado)">
                    <div class="modal-content">
                        <h2 class="simulator-title loaded" >

                        </h2>

                        <div class="form-group">
                            <label>Modo da base de cálculo</label>

                            <div class="flex-row mb-2 mt-2">
                                <div class="col-xs-12 col-sm">
                                    <input name="metodo" type="radio" class="with-gap" v-model.number="metodo" value="1" id="metodo-1"/>
                                    <label for="metodo-1">Normal</label>
                                </div>
                                <div class="col-xs-12 col-sm">
                                    <input id="metodo-2" name="metodo" type="radio" class="with-gap" v-model.number="metodo" value="2"/>
                                    <label for="metodo-2">Menor que</label>
                                </div>
                                <div class="col-xs-12 col-sm">
                                    <input id="metodo-3" name="metodo" type="radio" class="with-gap" v-model.number="metodo" value="3"/>
                                    <label for="metodo-3">Acima de</label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="flex-row">
                                <div class="col-xs-12 col-sm" v-if="metodo != 2">
                                    <label>
                                        {{ metodo == 3 ? 'Acima de' : 'Mínimo' }}
                                    </label>
                                    <money class="form-control validate" v-model="desconto_simplificado_selecionado.valor_minimo" placeholder="Valor mínimo" />

                                </div>
                                <div class="col-xs-2 col-sm" v-if="metodo != 3">
                                    <label>{{ metodo == 2 ? 'Menor que' : 'Máximo' }}</label>
                                    <money class="form-control" v-model="desconto_simplificado_selecionado.valor_maximo" placeholder="Valor máximo" />
                                </div>
                            </div>

                            <div class="flex-row">

                                <div class="col-xs-12 col-sm-6">
                                    <label>Desconto é em Porcentagem?</label>

                                    <div>
                                        <input type="radio" :value="0" id="ds-nao" v-model.number="desconto_simplificado_selecionado.porcentagem" />
                                        <label for="ds-nao">Não</label>
                                    </div>
                                    <div>
                                        <input type="radio" :value="1" id="ds-sim" v-model="desconto_simplificado_selecionado.porcentagem" />
                                        <label for="ds-sim">Sim</label>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6">
                                    <label>Desconto</label>
                                    <div>
                                        <template v-if="desconto_simplificado_selecionado.porcentagem === 1">
                                            <input type="number" step="0.1" min="0" class="form-control" v-model.number="desconto_simplificado_selecionado.desconto" placeholder="Alíquota">
                                        </template>
                                        <template v-else>
                                            <money class="form-control" v-model="desconto_simplificado_selecionado.desconto" />
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="right-align">
                                <button class="btn grey-light" type="button" @click="() => modal_form = false">Cancelar</button>
                                <button class="btn btn-default" type="submit">Salvar</button>
                            </div>
                        </div>
                    </div>
                </form>
            </modal>

        </div>
    </div>
</template>

<script>

import { api } from "@/helpers/api";

import modal from "@/helpers/wm-modal";

import Modal from '@/components/common/Modal/Base.vue';

import Auth from "@/store/auth";

export default  {


    components: { Modal },

    async created() {

       await this.carregar();
    },


    computed: {
        ano() {
            return this.$route.params.ano;
        },

        usuario ()
        {
            return Auth.state.user;
        },

        funcionario () {
            return this.usuario.pessoa.funcionario;
        },

        funcionario_cargo_id() {
            return this.funcionario.funcionario_cargo_id;
        },
    },


    data() {

        return {
            metodo: 1,
            descontos_simplificados: [],
            desconto_simplificado_selecionado: {},

            modal_form: false,
        }
    },

    methods: {

        async carregar() {

            const {data: {result: {data: descontos_simplificados}}} = await api.get('desconto-simplificado', {params: {
                ano: this.ano
            }});

            this.descontos_simplificados = descontos_simplificados;
        },

        form(desconto) {

            this.desconto_simplificado_selecionado = {...desconto};

            this.metodo = 1;

            if (desconto.valor_minimo === null){
                this.metodo = 2;
            } else if (desconto.valor_maximo === null) {
                this.metodo = 3;
            }

            this.modal_form = true
        },

        async excluir(desconto_simplificado_selecionado, index)
        {

            const resultado = await modal.confirm({
                text: 'Confirma a exclusão desse item?',
                title: 'Confirmar'
            })

            if (! resultado) return;

            await api.delete(`desconto-simplificado/${desconto_simplificado_selecionado.desconto_simplificado_id}`);

            this.descontos_simplificados.splice(index, 1);
        },

        async salvar()
        {

            const desconto = {...this.desconto_simplificado_selecionado};

            if (this.metodo == 2) {
                desconto.valor_minimo = null;
            } else if (this.metodo == 3) {
                desconto.valor_maximo = null;
            }


            if (desconto.desconto_simplificado_id) {
                await api.put(`desconto-simplificado/${desconto.desconto_simplificado_id}`, desconto);
            } else {
                const {data: {result: {data: resultado}}} = await api.post('desconto-simplificado', desconto);
                this.descontos_simplificados.push(resultado)
            }


            this.modal_form = false

            this.carregar();
        }
    },

    beforeDestroy() {
        $('#modal-form').modal('close')
    }
}
</script>



// WEBPACK FOOTER //
// src/components/desconto-simplificado/Form.vue